import React, { Component } from 'react';
import styles from './list-heading.scss';

export class ListHeading extends Component<{ translation }> {

  public render() {
    const { translation } = this.props;

    return <div className={styles.headingContainer}>
      <div className={styles.defaultColumn}>{translation.column_description}</div>
      <div className={styles.defaultColumn}>{translation.column_url_template}</div>
      <div className={styles.fixedColumn} />
      <div className={styles.fixedColumn} />
    </div>;
  }
}
